// ================ Action types ================ //

export const OPEN_PUSH_NOTIFICATION_MODAL_REQUEST = 'app/user/OPEN_PUSH_NOTIFICATION_MODAL_REQUEST';
export const CLOSE_PUSH_NOTIFICATION_MODAL_REQUEST =
  'app/user/CLOSE_PUSH_NOTIFICATION_MODAL_REQUEST';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.Cordova} */
const initialState = {
  pushNotificationModalOpen: false,
  pushNotificationModalData: {},
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case OPEN_PUSH_NOTIFICATION_MODAL_REQUEST:
      return { ...state, pushNotificationModalOpen: true, pushNotificationModalData: payload };
    case CLOSE_PUSH_NOTIFICATION_MODAL_REQUEST:
      return { ...state, pushNotificationModalOpen: false };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const openPushNotificationModalRequest = (data) => ({
  type: OPEN_PUSH_NOTIFICATION_MODAL_REQUEST,
  payload: data,
});
export const closePushNotificationModalRequest = () => ({
  type: CLOSE_PUSH_NOTIFICATION_MODAL_REQUEST,
});

// ================ Thunks ================ //

export const openPushNotificationModal = (title, message, url) => (dispatch) => {
  dispatch(openPushNotificationModalRequest({ title, message, url }));
};

export const closePushNotificationModal = () => (dispatch) => {
  dispatch(closePushNotificationModalRequest());
};
